import { PayCycleStatus } from '@aslanpay/portal-common-lib';

export const PayCycleStatusValues: Record<PayCycleStatus, { color: string; value: string }> = {
  PENDING: { color: 'paused', value: 'Pending' },
  IN_PROGRESS: { color: 'created', value: 'In progress' },
  COMPLETED: { color: 'active', value: 'Completed' },
};

export default PayCycleStatusValues;
